import React from 'react';

const modalDialogFooter = "_modal-dialog-footer_1vlrp_1";
const styles = {
	modalDialogFooter: modalDialogFooter
};

const ModalDialogFooter = ({ children }) => {
  return React.createElement("footer", { className: styles.modalDialogFooter, "data-zds": true }, children);
};

export { ModalDialogFooter };
//# sourceMappingURL=Footer.es.js.map
